import { getField, updateField } from 'vuex-map-fields';

const jurisdiction = {
	namespaced: true,
	state: {
		is_expanded: true,
		name: "both"
	},
	getters: {
		getField,
		getPackage(state){
			return {
				name: (state.name !== "both") ? state.name : null
			}
		}
	},
	mutations: {
		updateField
	}
}

const defendant = {
	namespaced: true,
	state: {
		is_expanded: true,
		first_name: null,
		middle_name: null,
		last_name: null,
		// first_name: "Bryan",
		// last_name: "Castillo",
		arrest_date: null,
		event_description: null
	},
	getters: {
		getField,
		getPackage(state){
			return {
				...state
			}
		}
	},
	mutations: {
		updateField
	}
};

const attorney_judge = {
	namespaced: true,
	state: {
		is_expanded: true,
		// prosecuting_attorney: null,
		defending_attorney: null,
		judge: null,
	},
	getters: {
		getField,
		getPackage(state){
			return {
				...state
			}
		}
	},
	mutations: {
		updateField
	}
}

const global = {
	state: {
		needs_agreement: true,
		bond_events: [],
		show_welcome_message: true,
		hide_form_mobile: false,
		is_loading: false,
		active_card: null,
		input_max: 25,
		report_url: 'https://www.scsolicitor9.org/dockets/Bond-Motions-Event-Report.pdf'
	},
	getters: {
		getField
	},
	mutations: {
		updateField,
		setBondEvents(state, value){
			state.bond_events.splice(0, state.bond_events.length, ...value);
		}
	},
	actions: {
		validateSearchOverall({ getters }){

			const { first_name, middle_name, last_name, arrest_date, event_description } = getters['defendant/getPackage'],
			// { defending_attorney,  prosecuting_attorney, judge } = getters['attorney_judge/getPackage'];
			{ defending_attorney, judge } = getters['attorney_judge/getPackage'];

			// if(!first_name && !middle_name && !last_name && !arrest_date && !event_description && !defending_attorney && !prosecuting_attorney && !judge){
			// 	return false;
			// }
			// return true;

			if(!first_name && !middle_name && !last_name && !arrest_date && !event_description && !defending_attorney && !judge){
				return false;
			}
			return true;

		},
		startSearch({ dispatch, commit, getters }) {

			dispatch('collapseAllMenus');

			commit('updateField', { path: 'active_card', value: null });

			const data = {
				jurisdiction: getters['jurisdiction/getPackage'],
				defendant: getters['defendant/getPackage'],
				attorney_judge: getters['attorney_judge/getPackage']
			}

			this._vm.$axios.post('/search-engine.php', data)
			.then(response => {
				commit('setBondEvents', response.data);
				commit('updateField', { path: 'show_welcome_message', value: false });
			})
			.catch( () => {
				this._vm.$notify({
					title: 'Error!',
					message: 'Something went wrong on our end. Please try again.',
					type: 'error'
				});
			})
			.finally( () => {
				commit('updateField', { path: 'is_loading', value: false });
			});
		},
		collapseAllMenus({ commit }){
			// commit('attorney_judge/updateField', { path: 'is_expanded', value: false });
			commit('updateField', { path: 'hide_form_mobile', value: true });
		}
	}
}

export default {
	strict: (process.env.NODE_ENV !== 'production'),
	...global,
	modules: {
		jurisdiction,
		defendant,
		attorney_judge
	}
};
